import React, { useEffect } from 'react';
import { Route } from 'react-router';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Path from 'routes/Path';
import HeaderCommunity from 'components/HeaderCommunity/HeaderCommunity';
import Footer from 'components/Footer/Footer';
import { Spinner } from 'components/Spinner/spinner';
import { manageZendeskButton } from 'functions/zendesk';

export default function CommunityRoute({ component: Component, authMode, zendesk = 'show', ...rest }) {
  const history = useHistory();
  const { isInitialized, userRole } = useSelector((state) => state.auth);

  useEffect(() => manageZendeskButton(zendesk), [zendesk]);

  useEffect(() => {
    if (!authMode || !isInitialized) return;
    if (!userRole && authMode === 'private') history.push(Path.loginPage);
    if (userRole && authMode === 'unauthed') history.push(Path.landingPage);
  }, [authMode, isInitialized, userRole, history]);

  const renderPage = (props) => (
    <>
      <HeaderCommunity />
      {!authMode || isInitialized ? <Component {...props} /> : <Spinner />}
      <Footer />
    </>
  );

  return <Route {...rest} render={(props) => renderPage(props)} />;
}
